/**
 * gRPC-web metadata shared across CCM ProtoUtils clients.
 * Intentionally does not import `user-api` or `proto-utils` so this module can load
 * without pulling the protobuf client graph. Call `registerProtoAccessTokenGetter`
 * once from `user-api` (after `UserAPI` is defined) so `Authorization` stays in sync.
 */
import {hasNonEmptyValue} from './has-non-empty-value';

let headers = {};
let accessTokenGetter = null;

/**
 * @param {() => string|undefined|null} getter - Returns the bearer access token (no "Bearer " prefix).
 */
export function registerProtoAccessTokenGetter(getter) {
    accessTokenGetter = typeof getter === 'function' ? getter : null;
}

export function getProtoHeaders() {
    const raw = accessTokenGetter ? accessTokenGetter() : '';
    const result = {...headers};

    // Bearer comes only from the getter; strip any stale `headers.Authorization`
    // so an empty token does not keep sending a previously merged header.
    delete result.Authorization;

    if (hasNonEmptyValue(raw)) {
        result.Authorization = `Bearer ${String(raw)}`;
    }

    return result;
}

export function setProtoHeaders(attributes) {
    headers = {
        ...headers,
        ...attributes,
    };
}
